export default __webpack_public_path__ + "static/broadcastImg2-d3b0a5a20b77f6402da0d378ebdaca88.png";